'use client'

export interface NativeIdTokenNonce {
  nativeRequestNonce: string
  supabaseNonce: string
}

export async function createNativeIdTokenNonce(): Promise<NativeIdTokenNonce> {
  const bytes = new Uint8Array(32)
  crypto.getRandomValues(bytes)

  const rawNonce = btoa(String.fromCharCode(...bytes))
  const encodedNonce = new TextEncoder().encode(rawNonce)
  const hashBuffer = await crypto.subtle.digest('SHA-256', encodedNonce)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashedNonce = hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('')

  return {
    nativeRequestNonce: hashedNonce,
    supabaseNonce: rawNonce
  }
}
